import type { HttpGet } from '@/shared/infra/http'
import type { ListUplandSpecies } from '@/shared/domain/use-cases'

export class EdgeListUplandSpeciesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListUplandSpecies = async () => {
    const result = await this.http.get<{ species: Record<string, unknown>[] }>({
      url: '/species?huntType=upland&isActive=true',
    })
    return (result.species ?? []).map((s) => ({
      id: s.id as string,
      name: s.name as string,
    }))
  }
}
